export default __webpack_public_path__ + "6079713b15302ea1c27cf1a7d2b4da9a.woff";